module.exports = "/assets/1cf0b6d3e98ff5f5b87eb42078a33dfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/W6.png
// module id = 3068
// module chunks = 0